import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new CachedRequest(1000 * 5)

export async function apiCheckLoggedIn() {
  instance.cycleSessionTimeout = false
  return instance.get(endpoint.checkLoggedIn)
}
